<template>
  <div>
    <loader :loading="loading"/>
    <div class="l-row" v-if="!loading">
      <form-group :label="$t('category.label')" :columns="6">
        <select v-model="filters.category" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="category in categories" :value="category" :key="category">{{ category }}</option>
        </select>
      </form-group>

      <form-group label="Código(s) do(s) produto(s)">
        <textarea
          class="form-textarea"
          v-model="filters.codes"
          @change="removeTrim"
          placeholder="99999, 99999, 99999, 99999" />
        <small class="form-help">Utilize vírgula (,) para múltiplos códigos.</small>
      </form-group>

      <form-group :label="$t('ageGroup.label')" :columns="6">
        <select v-model="filters.ageGroup" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="ageGroup in ageGroups" :value="ageGroup" :key="ageGroup">{{ $t(`${ageGroup}.label`) }}</option>
        </select>
      </form-group>

      <form-group :label="$t('gender.label')" :columns="6">
        <select v-model="filters.gender" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="gender in genders" :value="gender" :key="gender">{{ $t(`gender.${gender}.label`) }}</option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import Loader from '@/components/template/Loader'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      loading: true,
      categories: [],
      genders: [],
      ageGroups: [],
      filters: {
        codes: '',
        category: null,
        gender: null,
        ageGroup: null
      }
    }),
    props: {
      source: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      try {
        this.categories = await api.getCategories(this.source.type, this.source.identifier)
      } catch (err) {
        this.categories = []
      }

      try {
        this.genders = await api.getGenders(this.source.type, this.source.identifier)
      } catch (err) {
        this.genders = []
      }

      try {
        this.ageGroups = await api.getAgeGroups(this.source.type, this.source.identifier)
      } catch (err) {
        this.ageGroups = []
      }

      this.loading = false
    },
    methods: {
      formatCodes () {
        this.filters.codes = this.filters.codes.replace(/,{2,}/g, ',').replace(/, /g, ',')
      },
      removeTrim () {
        this.filters.codes = this.filters.codes.replace(/,+$/, '')
      }
    },
    watch: {
      'filters.codes' () {
        this.formatCodes()
      }
    },
    components: {
      FormGroup,
      Loader
    }
  }
</script>

<style lang="sass" scoped>
  .slider
    padding: 15px 8px 0
</style>



// WEBPACK FOOTER //
// Moovin.vue?4495013e